// extracted by mini-css-extract-plugin
export default {"settings":"n7slU96Rpcfu7Balrvzp","container":"vnvguC6PlK0FzsFxKl1h"};